// extracted by mini-css-extract-plugin
module.exports = {"container":"expandable-chip-list_container__F_KN5","title":"expandable-chip-list_title__lv4k4"};